'use client'

import { createContext, type ReactNode, useContext } from 'react'

/**
 * Whether the current visitor is a Cleartrip/Flyin employee, resolved on the SERVER from
 * the `userid` cookie and handed to the client tree. Server-resolved on purpose: gating a
 * render branch on a client-only cookie read makes SSR and hydration disagree.
 */
const InternalUserContext = createContext<boolean>(false)

interface InternalUserProviderProps {
    children: ReactNode
    isInternalUser?: boolean
}

export const InternalUserProvider = ({ children, isInternalUser = false }: InternalUserProviderProps) => (
    <InternalUserContext.Provider value={isInternalUser}>{children}</InternalUserContext.Provider>
)

export const useIsInternalUser = () => useContext(InternalUserContext)
